import React from "react";
import clsx from "clsx";
import { Box, Theme, Typography, withStyles } from "@material-ui/core";
import { ErrorBoundaryCall } from "../../utils/service";
import { ReactComponent as Computer } from "../../assets/icons/computer.svg";
import {
  boldFont,
  centerItemFlex,
  getRelativeFontSize,
  mediumFont,
} from "../../utils/styles";
import posthog from "posthog-js";

const styles: any = (theme: Theme) => ({
  root: {
    ...centerItemFlex,
    width: "100vw",
    height: "100vh",
    textAlign: "center",
  },
  title: {
    ...boldFont,
    fontSize: getRelativeFontSize(7),
    lineHeight: 1.6,
  },
  subTitle1: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    lineHeight: 1.2,
  },
  computer: {
    width: "100px",
    height: "100px",
  },
  subTitleCustomStyle: { marginBottom: theme.spacing(3) },
  titleCustomStyle: { marginBottom: theme.spacing(3) },
});

class ErrorBoundary extends React.Component<
  any,
  { hasError: boolean; errorDetails: string; component: any }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, errorDetails: "", component: "" };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    const errorInString = error.toString();
    const componentStack = errorInfo.componentStack;
    this.setState({
      errorDetails: errorInString,
      component: componentStack,
    });

    // Mark this session as having encountered an error in PostHog.
    // This will attach `session_has_error = true` to the `$exception` event,
    // which can then be used in an ingestion filter to keep only error sessions.
    try {
      posthog.captureException(error, {
        componentStack,
      });
      posthog.startSessionRecording();
    } catch (e) {
      // Swallow PostHog errors to avoid breaking the user experience
      // eslint-disable-next-line no-console
      console.error(e);
    }

    this.sendNotifyToDiscord(errorInString, componentStack);
  }

  sendNotifyToDiscord = async (title: any, description: any) => {
    try {
      const body = {
        stack: [
          {
            title: title,
            description: description,
          },
        ],
      };
      await ErrorBoundaryCall(body);
    } catch (error: any) {
      console.error(error);
    }
  };

  getTitle = (title: string, customStyle?: string) => {
    return (
      <Typography className={clsx(this.props.classes.title, customStyle)}>
        {title}
      </Typography>
    );
  };

  getSubTitle = (subTitle: string, customStyle?: string) => {
    return (
      <Typography className={clsx(this.props.classes.subTitle1, customStyle)}>
        {subTitle}
      </Typography>
    );
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      try {
        const { classes } = this.props;
        return (
          <Box className={classes.root}>
            <Box mx={8} mb={5}>
              <Computer className={classes.computer} />
              {this.getTitle("On no!")}
              {this.getTitle(
                "Something went wrong :(",
                classes.titleCustomStyle
              )}
              {this.getSubTitle(
                "Please exit this browser tab and scan the QR code again.",
                classes.subTitleCustomStyle
              )}
              {/* <Typography className={classes.subTitle2}>
                If need further assistance or have any questions, please email
                us at support@glyde.app
              </Typography> */}
            </Box>
          </Box>
        );
      } catch (error) {
        throw error;
      }
    }

    return this.props.children;
  }
}

export default withStyles(styles)(ErrorBoundary);
